

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { LoyaltyContext } from '../../../context/loyalty/LoyaltyContext';
import { useForm } from '../../../components/hooks/useForm';
import Message from '../../../components/ui/Message';
import { WalletConfigLink } from '../settings/wallet/WalletConfigLink';
import moment from 'moment';




export const InfoLoyaltyClientPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { resendCard } = useContext(LoyaltyContext);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [services, setServices] = useState([]);
    const [client, setClient] = useState(null);

    var supplier;

    if (state && client == null) {
        setClient(state.client);
    }



    const handleResend = async () => {
        const resp = await resendCard(client.loyaltyMemberId, client.correo);
        if (resp == "success") {
            setSuccessMessage("Tarjeta reenviada correctamente");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (
        <>
            <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


                <div className='col-md-10 row'>


                    {
                        client != null ?
                            <div className="table-responsive">
                                <table className="table table-hover table-striped">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Correo</th>
                                            <th>Tarjeta</th>
                                            <th>Puntos Actuales</th>
                                            <th>Sellos Actuales</th>
                                            <th>Fecha Registro</th>
                                            <th>Plataforma</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key={client.id}>
                                            <td>{client.nombre}</td>
                                            <td>{client.correo}</td>
                                            <td>{client.loyaltyMemberId}</td>
                                            <td>{client.puntosActuales}</td>
                                            <td>{client.sellosActuales}</td>
                                            <td>{moment(client.fechaRegistro).format('LL')}</td>
                                            <td>{client.plataforma}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> : <div></div>

                    }
                    <div className='container d-flex align-items-center justify-content-center mt-5 mb-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleResend} className="btn btn-primary ms-5">Reenviar tarjeta</button>
                    </div>


                    <div style={{ height: '100px' }}></div>
                </div>

                {
                    errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)'>
                    <WalletConfigLink message={errorMessage} />
                </Message> : ''
                }
                {
                    successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                }



            </div>

        </>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
